import { useEffect, useState } from "react";
import PageLoader from "../../components/PageLoader";
import EmptyDashboard from "./EmptyDashboard";
import FullDashboard from "./FullDashboard";
import { getStore } from '../../models/store';

export default function Dashboard() {
  const [store, setStore] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      const data = await getStore();
      if (mounted) {
        setStore(data && data._static ? null : data); // if only static fallback, treat as empty
        setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <PageLoader loading={loading}>
      {(!store) ? <EmptyDashboard /> : <FullDashboard store={store} />}
    </PageLoader>
  );
}
